import { zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export const MrvEvent = zObj({
    IMO: zNum(),
    Date_UTC: zStr(), // yyyy-mm-dd,
    Time_UTC: zStr(), // hh:mm,
    Voyage: zObj({
        Voyage_From: zStr(), //UN/LOCODE
        Voyage_To: zStr(), //UN/LOCODE
        Offhire_Reasons: zOptional(zStr()),
    }),
    Event: zStr(),
    Time_elapsed: zObj({
        Time_Since_Previous_Report: zNum(), // h
        Time_Elapsed_Sailing: zOptional(zNum()), // h
        Time_Elapsed_Anchoring: zOptional(zNum()), // h
        Time_Elapsed_DP: zOptional(zNum()), // h
        Time_Elapsed_Maneuvering: zOptional(zNum()), // h
        Time_Elapsed_Loading_Unloading: zOptional(zNum()), // h
    }),
    Distance: zNum(), // NM
    Position: zObj({
        Latitude: zObj({ Latitude_Degree: zNum(), Latitude_Minutes: zNum(), Latitude_North_South: zStr() }),
        Longitude: zObj({ Longitude_Degree: zNum(), Longitude_Minutes: zNum(), Longitude_East_West: zStr() }),
    }),
    Cargo: zObj({ Cargo_Mt: zNum(), Cargo_m3: zNum(), Passengers: zOptional(zNum()) }),
    Consumption: zObj({
        Main_engines: zObj({
            ME_Consumption_HFO: zOptional(zNum()), // MT
            ME_Consumption_LFO: zOptional(zNum()), // MT
            ME_Consumption_MGO: zOptional(zNum()), // MT
            ME_Consumption_MDO: zOptional(zNum()), // MT
            ME_Consumption_LPGP: zOptional(zNum()), // MT
            ME_Consumption_LPGB: zOptional(zNum()), // MT
            ME_Consumption_LNG: zOptional(zNum()), // MT
            ME_Consumption_M: zOptional(zNum()), // MT
            ME_Consumption_E: zOptional(zNum()), // MT
            ME_Consumption_O: zOptional(zNum()), // MT
            ME_Consumption_O_type: zOptional(zStr()),
        }),
        Aux_engines: zObj({
            AE_Consumption_HFO: zOptional(zNum()), // MT
            AE_Consumption_LFO: zOptional(zNum()), // MT
            AE_Consumption_MGO: zOptional(zNum()), // MT
            AE_Consumption_MDO: zOptional(zNum()), // MT
            AE_Consumption_LPGP: zOptional(zNum()), // MT
            AE_Consumption_LPGB: zOptional(zNum()), // MT
            AE_Consumption_LNG: zOptional(zNum()), // MT
            AE_Consumption_M: zOptional(zNum()), // MT
            AE_Consumption_E: zOptional(zNum()), // MT
            AE_Consumption_O: zOptional(zNum()), // MT
            AE_Consumption_O_type: zOptional(zStr()),
        }),
        Boilers: zOptional(zObj({
            Boiler_Consumption_HFO: zOptional(zNum()), // MT
            Boiler_Consumption_LFO: zOptional(zNum()), // MT
            Boiler_Consumption_MGO: zOptional(zNum()), // MT
            Boiler_Consumption_MDO: zOptional(zNum()), // MT
            Boiler_Consumption_LPGP: zOptional(zNum()), // MT
            Boiler_Consumption_LPGB: zOptional(zNum()), // MT
            Boiler_Consumption_LNG: zOptional(zNum()), // MT
            Boiler_Consumption_M: zOptional(zNum()), // MT
            Boiler_Consumption_E: zOptional(zNum()), // MT
            Boiler_Consumption_O: zOptional(zNum()), // MT
            Boiler_Consumption_O_type: zOptional(zStr()),
        })),
        Inert_gas_generators_and_gas_combustion_units: zOptional(zObj({
            Inert_gas_Consumption_HFO: zOptional(zNum()), // MT
            Inert_gas_Consumption_LFO: zOptional(zNum()), // MT
            Inert_gas_Consumption_MGO: zOptional(zNum()), // MT
            Inert_gas_Consumption_MDO: zOptional(zNum()), // MT
            Inert_gas_Consumption_LPGP: zOptional(zNum()), // MT
            Inert_gas_Consumption_LPGB: zOptional(zNum()), // MT
            Inert_gas_Consumption_LNG: zOptional(zNum()), // MT
            Inert_gas_Consumption_M: zOptional(zNum()), // MT
            Inert_gas_Consumption_E: zOptional(zNum()), // MT
            Inert_gas_Consumption_O: zOptional(zNum()), // MT
            Inert_gas_Consumption_O_type: zOptional(zStr()),
        })),
        Incinerators: zOptional(zObj({
            Incinerator_Consumption_O: zOptional(zNum()), // MT
            Incinerator_Consumption_O_Type: zOptional(zStr()),
        })),
    }),
    ROB: zObj({
        HFO_ROB: zOptional(zNum()), // MT
        LFO_ROB: zOptional(zNum()), // MT
        MGO_ROB: zOptional(zNum()), // MT
        MDO_ROB: zOptional(zNum()), // MT
        LPGP_ROB: zOptional(zNum()), // MT
        LPGB_ROB: zOptional(zNum()), // MT
        LNG_ROB: zOptional(zNum()), // MT
        Methanol_ROB: zOptional(zNum()), // MT
        Ethanol_ROB: zOptional(zNum()), // MT
        O_ROB: zOptional(zNum()), // MT
        O_ROB_type: zOptional(zStr()),
    }),
});
// type MRC = {
// 	date: { date: string; time: string }
// 	voyage: { from: string; to: string; offhireReasons: string }
// 	position: {
// 		lat: { degrees: number; minutes: number; northSouth: "North" | "South" }
// 		lon: { degrees: number; minutes: number; eastWest: "East" | "West" }
// 	}
// 	event: "Departure" | "Arrival" | "Noon" | "STS" | "OTHERS..."
// 	time: {
// 		previousEvent: number
// 		atAnchor: number
// 		dp: number
// 		navigatinInIce: number
// 		maneuvering: number
// 		waiting: number
// 		loadingUnloading: number
// 		Drifting: number
// 	}
// 	distance: { overGround: number; overIce: number }
// 	cargo: {
// 		weight: number
// 		volune: number
// 		passengers: number
// 		containers: { reefer20ftChilled: number; reefer40ftChilled: number; reefer20ftFrozen: number; reefer40ftFrozen: number }
// 	}
// 	consumption: {
// 		HFO: number
// 		LFO: number
// 		MGO: number
// 		MDO: number
// 		LPG: number
// 		LNG: number
// 		Methanol: number
// 		Ethanol: number
// 		other: number
// 		otherFuelType: string
// 	}
// 	remainingOnBoard: {
// 		HFO: number
// 		LFO: number
// 		MGO: number
// 		MDO: number
// 		LPG: number
// 		LNG: number
// 		Methanol: number
// 		Ethanol: number
// 		other: number
// 		otherFuelType: string
// 	}
// }
//# sourceMappingURL=mrv.js.map